import React from 'react';
import { Button, Form, Modal, Select } from 'antd';
import { func } from 'helpers';

const Payment = props => {
    const { award, title, amount, visible, isForeign } = props;

    const [form] = Form.useForm();
    const [submitting, setSubmitting] = React.useState(false);

    React.useEffect(() => {
        setSubmitting(false);
    }, []);

    const close = () => {
        props.onCancel();
        form.resetFields();
    }

    const submit = (v) => {
        props.onSuccess(v);
        setSubmitting(false);
    }

    const country = isForeign.isForeign ? award.country : { code: isForeign.country, currency: isForeign.currency };
    const paymentMethods = props._data.paymentMethods[country.code];
    console.log(props._data.paymentMethods, isForeign, country);

    return (
        <React.Fragment>
            <Modal open={visible} title={title} width={400} centered footer={null} maskClosable={false} onCancel={close}>
                <Form form={form} layout="vertical" onFinish={submit}>
                    <Form.Item
                        name="pay_with" label="Payment method"
                        rules={[{ required: true, message: func.intl('Alert.Required', 'This field is required!'), },]}
                    >
                        <Select size="large" autoComplete="off" placeholder="Choose an option" disabled={submitting}>
                            {paymentMethods.map((option, i) => (
                                option.value === 'break' ?
                                    <Select.Option key={i} disabled={true}>::::: {option.label} </Select.Option> :
                                    <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    {amount && (
                        <div className="alert alert-info text-center mt-4 p-10">
                            {func.intl('Text.YouPay', 'You will pay')}:
                            <div>
                                <div style={{ fontSize: 20, fontWeight: 800 }}>
                                    {isForeign.currency} {func.numberFormat(amount * isForeign.forex.rate, isForeign.decimal)}
                                </div>
                                {isForeign.isForeign ? <div className="text-muted" style={{ fontSize: 12 }}>({func.intl('Text.EstimatedAmount', 'estimated amount')})</div> : ''}
                            </div>
                        </div>
                    )}

                    <div className="row mt-4">
                        <div className="col-1"></div>
                        <div className="col-10">
                            <Button shape="round" size="large" block type="primary" htmlType="submit" loading={submitting}>
                                {func.intl('Button.MakePayment', 'Make payment')}
                            </Button>
                        </div>
                        <div className="col-1"></div>
                    </div>
                </Form>
            </Modal>
        </React.Fragment>
    );
};

export default Payment;